/**
 * Application Entry Point
 *
 * This is the main entry point for the React application.
 * It renders the App component into the DOM.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initAnalytics } from './services/analytics';

initAnalytics();

// Get the root DOM element
const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

// Create a root
const root = createRoot(container);

// Initial render: Render your App component to the root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
